function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent } from '../../../../wdh-foundation/wdh';

/**
 * @memberOf module:wdh-geo-ip-prompt
 */
var WDHGeoIpPrompt = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHGeoIpPrompt() {
    var _this;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'geo-ip-prompt';
    _classCallCheck(this, WDHGeoIpPrompt);
    _this = _callSuper(this, WDHGeoIpPrompt, [className]);

    /**
     * Sets the z-index for the pop-up, which should be high enough for it to overlay everything else on the page.
     * @type {number}
     * @default 1000
     */
    _this.zIndex = 1000;

    /**
     * Decides wether the "x" button will be created on the pop-up. This button will dismiss the pop-up when clicked.
     * @type {boolean}
     * @default true
     */
    _this.showDismissButton = true;

    /**
     * Decides wether the user can dismiss the pop-up when he clicks outside the pop-up dialog box.
     * @type {boolean}
     * @default true
     */
    _this.dismissOnClickOutsidePopup = true;

    /**
     * Avoids redirecting from subpage back to main page after cookie is accepted
     * @type {boolean}
     * @default false
     */
    _this.goToCountrySubPage = false;

    /**
     * The name of the cookie that is set when the prompt is dismissed.
     * @type {string}
     * @default 'geo_ip_prompt_dismissed'
     */
    _this.cookieName = 'geo_ip_prompt_dismissed';
    return _this;
  }
  _inherits(WDHGeoIpPrompt, _WDHComponent);
  return _createClass(WDHGeoIpPrompt, [{
    key: "init",
    value: function init(component) {
      if (!this.isDismissed() && this.hasContent(component)) {
        component.classList.add('show');
        if (this.dismissOnClickOutsidePopup) {
          this.setComponentClickListener(component);
        }
        if (this.showDismissButton) {
          this.createDismissButton(component);
        }
        if (this.goToCountrySubPage) {
          this.decorateCountryHref(component);
        }
        this.setStayButtonClickListener(component);
        this.setZIndex(component);
      }
    }
  }, {
    key: "isDismissed",
    value: function isDismissed() {
      return window.DGS.Cookies.getInstance().readCookie(this.cookieName) != null;
    }
  }, {
    key: "hasContent",
    value: function hasContent(component) {
      var contentChildren = _toConsumableArray(component.firstElementChild.children);
      var hasContent = false;
      contentChildren.forEach(function (child) {
        if (child.children.length > 0 && child.innerHTML !== '<a href="#"></a>') {
          hasContent = true;
        }
      });
      return hasContent;
    }
  }, {
    key: "setComponentClickListener",
    value: function setComponentClickListener(component) {
      var _this2 = this;
      component.addEventListener('click', function (e) {
        _this2.onComponentClick(e, component);
      });
    }
  }, {
    key: "onComponentClick",
    value: function onComponentClick(e, component) {
      if (e.target === component) {
        this.dismiss(component);
      }
    }
  }, {
    key: "dismiss",
    value: function dismiss(component) {
      component.classList.remove('show');
      window.DGS.Cookies.getInstance().createCookie(this.cookieName, 1, 30);
    }
  }, {
    key: "createDismissButton",
    value: function createDismissButton(component) {
      var _this3 = this;
      var dismissButton = document.createElement('div');
      var componentContent = component.getElementsByClassName('component-content')[0];
      dismissButton.classList.add('geo-ip-prompt-dismiss');
      dismissButton.textContent = 'x';
      dismissButton.addEventListener('click', function () {
        _this3.onDismissClick(component);
      });
      componentContent.insertBefore(dismissButton, componentContent.firstChild);
    }
  }, {
    key: "decorateCountryHref",
    value: function decorateCountryHref(component) {
      var link = component.querySelector('.geo-ip-prompt-countryspecificsite a');
      var newHref = link.href;
      var pathname = window.location.pathname;
      if (newHref.substr(-1) === '/') {
        newHref = newHref.substr(0, newHref.length - 1);
      }
      if (pathname.substr(0, 1) === '/') {
        pathname = pathname.substr(1);
      }
      link.href = newHref + '/' + pathname;
    }
  }, {
    key: "onDismissClick",
    value: function onDismissClick(component) {
      this.dismiss(component);
    }
  }, {
    key: "setStayButtonClickListener",
    value: function setStayButtonClickListener(component) {
      var _this4 = this;
      var stayButton = component.querySelector('.geo-ip-prompt-currentsite a');
      stayButton.href = ''; // Removes the # from href to keep the site from scrolling. This is related to the hacky solution of anchor handling in dgs-api
      stayButton.addEventListener('click', function (event) {
        event.preventDefault();
        _this4.onDismissClick(component);
      });
    }
  }, {
    key: "setZIndex",
    value: function setZIndex(component) {
      component.style.zIndex = this.zIndex;
    }
  }]);
}(WDHComponent);
export default WDHGeoIpPrompt;